import { useContext } from "react";
import _ from "lodash";
import { UserContext } from "../context/UserContext";
import ConfigUtils from "../utils/ConfigUtils";
import { PERMITTED_ROLES } from "../constants/UserRoles";

const useStoreConfig = () => {
  const { assignedTo, department } = useContext(UserContext);  
  let payloads = {}, ConfigStore;

  const createGetter = (val, propertyName, decorator) => {
    return () => {
      if (!payloads[propertyName]) {
        payloads[propertyName] = _.isFunction(decorator) ? decorator(val) : val;
      }
      return payloads[propertyName];
    };
  };

  const transFormObject = (obj) => {
    let renameObj = Object.assign({}, obj);
    renameObj["value"] = _.get(obj, "type", _.get(obj, "jobType"));
    return _.omit(renameObj, ["type", "jobType"]);
  };

  const getParentLabelValue = function (val) {
    let arr = [];
    _.map(val, function (item) {
      let pickValue = _.pick(item, ["label", "jobType", "hideFromUI"]);
      if (!_.isEmpty(pickValue.label)) {
        arr.push(transFormObject(pickValue));
      }
    });
    return _.reject(arr, _.isEmpty);
  };

  const getIdType = (values, userRole, dashboardView=null) => {
    const sourceLocationFields = ConfigUtils.getSourceLocations().filter(item => item.value !== 'discovery');
    let val = dashboardView === "jobs" && _.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, userRole)
    ? [...values, ...sourceLocationFields] : values;
    return val;
  };

  const getChildLabelValue = function (val) {
    let arr = [];
    const jobTypes = _.map(val, (sourceType) => {
      return _.get(sourceType, "sourceDefinition");
    });
    _.map(jobTypes, function (item) {
      _.map(item, function (nestedItem) {
        if (!_.isEmpty(_.get(nestedItem, "label")))
          arr.push(transFormObject(_.pick(nestedItem, ["label", "type", "role", "hideFromUI"])));
      });
    });
    return _.uniqBy(_.reject(arr, _.isEmpty), "value");
  };

  let _internals = {
    filterConfig: function (val) {
      _.map(val, (filter) => {
        if (!_.isArray(filter.values)) {
          switch (filter.values.function.name) {
            case "requestorStatuses":
              filter.values = _.result(_.find(ConfigStore.statuses(), { role: "requestor" }), "statuses");
              filter.values = _.reject(filter.values, (item) => {
                return /(^(WF_QC_IN_PROGRESS|DRAFT|INITIATE_STEAM|INITIATE_WORKFLOW|WF_SOURCE_MISSING|WF_PROCESSING|WF_DONE|WF_PARTIAL|WF_DELIVERING|WF_SOURCING|WF_ERROR|VETTED|PAC_READY|WF_VIP|WF_VIP_INITIATED|WF_VIP_PROCESSING|WF_VIP_VIDEO_ARRIVED|WF_VIP_MMRK|WF_VIP_ERROR)$)/.test(
                  item.value
                );
              });
              break;
            case "adminOpStatuses":
              filter.values = _.result(_.find(ConfigStore.statuses(), { role: "ops" }), "statuses");
              break;
            case "crApiStatuses":
              filter.values = _.result(_.find(ConfigStore.statuses(), { role: "cr_api" }), "statuses");
              break;
            case "mediaRequestStatuses":
              filter.values = _.result(_.find(ConfigStore.statuses(), { role: "mediarequest" }), "statuses");
              break;
            case "jobTypes":
              filter.values = _.reject(ConfigStore.jobTypeList(), _.isEmpty);
              break;
            case "sourceTypes":
              var sourceList = ConfigStore.sourceTypes().sort(function (a, b) {
                return (
                  _.get(a, "label", "").toLowerCase() > _.get(b, "label", "").toLowerCase() &&
                  _.get(a, "active", "") === true &&
                  _.get(b, "active", "") === true
                );
              });
              filter.values = _.reject(sourceList, _.isEmpty);
              break;
            case "assignedTo":
              filter.values = _.map(assignedTo, (user) => {
                return { value: user.oktaUid, label: user.fullName };
              });

              break;
            case "deptName":
              filter.values = _.map(department, (dept) => {
                return { value: dept, label: dept };
              });

              break;
            case "deliveryType":
              const deliveryVal = _.map(ConfigUtils.getDeliveryMapping(), (delMapping) => {
                return { value: _.get(delMapping, "label"), label: _.get(delMapping, "label"), hideFromUI: _.get(delMapping,"hideFromUI",false) };
              });

              filter.values = _.uniqBy(deliveryVal, "label");
              break;
          }
        }
        return filter;
      });
      return val;
    },
  };
  ConfigStore = {
    deliverToTypesByOption: createGetter(ConfigUtils.getDeliveryTypes(), "deliverToTypesByOption", (val) => {
      return _.indexBy(val, "label");
    }),
    sourceTypes: createGetter(ConfigUtils.getJobTypes(), "sourceTypes", getChildLabelValue),
    statuses: createGetter(ConfigUtils.getStatuses(), "statuses", null),
    jobTypeList: createGetter(ConfigUtils.getJobTypes(), "jobTypes", getParentLabelValue),
    deliverToTypes: createGetter(ConfigUtils.getDeliveryTypes(), "deliverToTypes", null),
    filtersField: createGetter(ConfigUtils.getCustomFilters(), "filters", _internals.filterConfig),
  };

  return {
    ConfigStore,
    getIdType,
  };
};

export default useStoreConfig;
